/** @format */

import moment from "moment/moment";
import { Link } from "react-router-dom";
import { devise } from "./utils";

// ─── Statut du message ───────────────────────────────────────────────────────
const MessageStatus = ({ status, isOutgoing }) => {
  if (!isOutgoing) return null; // N'afficher le statut que sur les messages sortants

  if (status === "seen") {
    return (
      <span className='text-blue-400 text-xs font-bold tracking-tight'>vv</span>
    );
  }
  if (status === "unseen") {
    return <span className='text-gray-400 text-xs font-bold'>v</span>;
  }
  return <span className='text-red-400 text-xs'>!</span>;
};

// ─── Composant principal ─────────────────────────────────────────────────────
function MessageUx({ message, isOutgoing = false }) {
  // Palette selon direction
  // Sortant (customer) : bleu
  // Entrant (seller)   : blanc avec bordure grise
  const bubbleBase = isOutgoing
    ? "bg-blue-500 text-white rounded-2xl rounded-br-sm shadow-sm"
    : "bg-white text-gray-800 border border-gray-200 rounded-2xl rounded-bl-sm shadow-sm";

  const textCaption = isOutgoing ? "text-blue-200" : "text-gray-400";

  return (
    <div className='flex flex-col gap-0.5'>
      {/* ── Bulle principale ───────────────────────────────────────────── */}
      {message.messageType === "image" ? (
        <div className={`p-2 ${bubbleBase} grid gap-1.5`}>
          {message.images.map((url, index) => (
            <img
              key={index}
              src={url}
              className='max-w-[200px] rounded-lg object-cover'
              alt='chat-img'
            />
          ))}
          {message?.message?.trim() !== "" && (
            <p className='text-sm px-1 pt-1'>{message.message}</p>
          )}
        </div>
      ) : message.messageType === "product" ? (
        <div className='p-2 bg-white border border-gray-200 rounded-2xl shadow-sm max-w-xs text-gray-800'>
          <img
            src={message.productInfo.image}
            alt='product'
            className='w-full h-[100px] object-cover rounded-lg'
          />
          <div className='mt-2 space-y-0.5'>
            <h4 className='text-red-500 font-bold text-sm'>
              {message.productInfo.title}
            </h4>
            <p className='text-green-600 font-semibold text-sm'>
              {message.productInfo.price} {devise}
            </p>
            <p className='text-gray-400 text-xs'>
              Stock : {message.productInfo.stock}
            </p>
            <p className='text-gray-400 text-xs'>
              {message.productInfo.message}
            </p>
            <Link
              to={`/product/details/${message.productInfo.productId}`}
              className='text-blue-500 underline text-xs'
            >
              Voir le produit
            </Link>
          </div>
        </div>
      ) : message.messageType === "order" ? (
        <div className='p-3 bg-white border border-gray-200 rounded-2xl shadow-sm max-w-md text-gray-800'>
          <h3 className='text-blue-600 font-bold mb-2 text-sm'>
            Commande envoyee
          </h3>
          <p className='text-xs text-gray-600 mb-2'>
            Bonjour {message.orderInfo.shopName}, j'ai placé cette commande,
            veuillez m'assister pour le paiement.
          </p>
          <div className='border-t pt-2 space-y-3'>
            {message.orderInfo.products.map((product, index) => (
              <div key={index} className='flex gap-3 items-center'>
                <img
                  src={product.image}
                  className='w-[52px] h-[52px] object-cover rounded-lg'
                  alt='product'
                />
                <div className='text-xs flex-1'>
                  <h4 className='font-semibold text-red-500'>
                    {product.title}
                  </h4>
                  <p className='text-gray-500'>Qte : {product.quantity}</p>
                  <p className='text-gray-500'>
                    {product.unitPrice} {devise}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className='border-t mt-3 pt-2 flex items-center justify-between'>
            <p className='font-bold text-green-600 text-sm'>
              Total : {message.orderInfo.totalPrice.toFixed(2)} {devise}
            </p>
            <Link
              to={`/dashboard/order/details/${message.orderInfo.orderId}`}
              className='text-blue-500 underline text-xs'
            >
              Voir la commande
            </Link>
          </div>
        </div>
      ) : (
        // ── Message texte simple ──────────────────────────────────────────
        <div className={`px-3 py-2 ${bubbleBase}`}>
          <p className='text-sm leading-relaxed break-words'>
            {message.message}
          </p>
        </div>
      )}

      {/* ── Méta : heure + statut ─────────────────────────────────────── */}
      <div
        className={`flex items-center gap-1.5 px-1 ${isOutgoing ? "justify-end" : "justify-start"}`}
      >
        <time className={`text-[11px] ${textCaption}`}>
          {moment(message.createdAt).fromNow()}
        </time>
        <MessageStatus status={message.status} isOutgoing={isOutgoing} />
      </div>
    </div>
  );
}

export default MessageUx;
